var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 17.7078V19.7378C10.7516 21.4578 9.15158 22.8478 7.18158 22.8478C5.21158 22.8478 3.60156 21.4578 3.60156 19.7378V17.7078C3.60156 19.4278 5.20158 20.6478 7.18158 20.6478C9.15158 20.6478 10.7516 19.4178 10.7516 17.7078Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7501 14.9574C10.7501 15.4574 10.6101 15.9174 10.3701 16.3174C9.78006 17.2874 8.57004 17.8974 7.17004 17.8974C5.77004 17.8974 4.56003 17.2774 3.97003 16.3174C3.73003 15.9174 3.59009 15.4574 3.59009 14.9574C3.59009 14.0974 3.99007 13.3274 4.63007 12.7674C5.28007 12.1974 6.17003 11.8574 7.16003 11.8574C8.15003 11.8574 9.04006 12.2074 9.69006 12.7674C10.3501 13.3174 10.7501 14.0974 10.7501 14.9574Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 14.9574V17.7074C10.7516 19.4274 9.15158 20.6474 7.18158 20.6474C5.21158 20.6474 3.60156 19.4174 3.60156 17.7074V14.9574C3.60156 13.2374 5.20158 11.8474 7.18158 11.8474C8.17158 11.8474 9.06161 12.1974 9.71161 12.7574C10.3516 13.3174 10.7516 14.0974 10.7516 14.9574Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.8173V13.8774C22 14.4274 21.56 14.8773 21 14.8973H19.0399C17.9599 14.8973 16.97 14.1073 16.88 13.0273C16.82 12.3973 17.0599 11.8073 17.4799 11.3973C17.8499 11.0173 18.36 10.7974 18.92 10.7974H21C21.56 10.8174 22 11.2673 22 11.8173Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.3474V9.34741C2 6.62741 3.64 4.72741 6.19 4.40741C6.45 4.36741 6.72 4.34741 7 4.34741H16C16.26 4.34741 16.51 4.3574 16.75 4.3974C19.33 4.6974 21 6.60741 21 9.34741V10.7974H18.92C18.36 10.7974 17.85 11.0174 17.48 11.3974C17.06 11.8074 16.82 12.3974 16.88 13.0274C16.97 14.1074 17.96 14.8974 19.04 14.8974H21V16.3474C21 19.3474 19 21.3474 16 21.3474H13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.c09b1ac377acef0710bcdc2efc73c17e.svg";
export { ForwardRef as ReactComponent };